import { z } from 'zod'

export const CRM_DRIP_ENROLLMENT_CONTRACT_VERSION = '1.0.0' as const

const rowSchema = z.record(z.unknown())
const optionalQueryString = z.preprocess(
  (value) => (typeof value === 'string' ? value : undefined),
  z.string().optional(),
)

export const crmDripEnrollmentQuerySchema = z.object({
  orgId: optionalQueryString,
  org_id: optionalQueryString,
  limit: optionalQueryString,
  status: optionalQueryString,
  sequenceId: optionalQueryString,
  sequence_id: optionalQueryString,
  contactId: optionalQueryString,
  contact_id: optionalQueryString,
}).passthrough()

export const crmDripEnrollmentResponseSchema = z.object({
  contract_version: z.literal(CRM_DRIP_ENROLLMENT_CONTRACT_VERSION),
  enrollment: rowSchema,
  replayed: z.boolean().optional(),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmDripEnrollmentListResponseSchema = z.object({
  contract_version: z.literal(CRM_DRIP_ENROLLMENT_CONTRACT_VERSION),
  enrollments: z.array(rowSchema),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmDripEnrollmentReadErrorEnvelopeSchema = z.object({
  contract_version: z.string().min(1),
  error: z.object({ code: z.string().min(1), message: z.string().min(1), reference: z.string().min(1) }).passthrough(),
}).passthrough()

export type CrmDripEnrollmentQuery = z.infer<typeof crmDripEnrollmentQuerySchema>
export type CrmDripEnrollmentResponse = z.infer<typeof crmDripEnrollmentResponseSchema>
export type CrmDripEnrollmentListResponse = z.infer<typeof crmDripEnrollmentListResponseSchema>
export type CrmDripEnrollmentReadErrorEnvelope = z.infer<typeof crmDripEnrollmentReadErrorEnvelopeSchema>
